import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { adminVerify, getToken } from "@/lib/adminApi";

export const AdminGuard = ({ children }) => {
  const navigate = useNavigate();
  const [state, setState] = useState("checking");

  useEffect(() => {
    let active = true;
    if (!getToken()) {
      navigate("/admin/login", { replace: true });
      return;
    }
    adminVerify()
      .then(() => active && setState("ok"))
      .catch(() => {
        if (active) navigate("/admin/login", { replace: true });
      });
    return () => {
      active = false;
    };
  }, [navigate]);

  if (state !== "ok") {
    return (
      <div className="min-h-screen grid place-items-center bg-[#0E0F10]">
        <Loader2 className="w-8 h-8 animate-spin text-[#C8A24A]" />
      </div>
    );
  }
  return children;
};

export default AdminGuard;
